import { GetServerSideProps, NextPage } from 'next';
import Script from 'next/script';

export const getServerSideProps: GetServerSideProps = async () => {
  return { props: {} };
};

const ReelsPage: NextPage = () => {
  return (
    <>
      <Script id="aller-video-loader-cdn" src="https://cdn.video.aller.com/reels/latest/script.js" type="module" />
      <div id="video-reels-root"></div>
    </>
  );
};

export default ReelsPage;
